//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import flagProductModalMixin from '@motionelements/catalog/src/modules/product/mixins/flag-product-modal-mixin.js';

export default {
  name: 'FlagProductModal',
  components: {
    BaseSelect: () => import('@motionelements/core/src/components/ui/form/BaseSelect.vue'),
    BaseTextarea: () => import('@motionelements/core/src/components/ui/form/BaseTextarea.vue'),
    ButtonLadda: () => import('@motionelements/core/src/components/ui/BaseButtonLadda.vue'),
  },
  mixins: [flagProductModalMixin],
  methods: {
    hideModal() {
      this.$bvModal.hide('flag-product-modal');
    },
    hidden() {
      this.reset();
    },
  },
};
